export default __webpack_public_path__ + "static/media/D1195.590c7403.webp";